import React, { useState } from 'react';
import './BlockDrawer.css';

const BlockDrawer = ({ step, onUpdate, onClose }) => {
    const [config, setConfig] = useState(step.config);

    const handleSave = () => {
        onUpdate({
            config: config
        });
        onClose();
    };



    const renderEmailConfig = () => (
        <div className="drawer-section">
            <h4>Email Configuration</h4>
            <div className="form-group">
                <label>Subject</label>
                <input
                    type="text"
                    value={config.subject || ''}
                    onChange={(e) => setConfig({...config, subject: e.target.value})}
                    placeholder="Enter email subject"
                />
            </div>
            <div className="form-group">
                <label>To</label>
                <input
                    type="email"
                    value={config.to || ''}
                    onChange={(e) => setConfig({...config, to: e.target.value})}
                    placeholder="recipient@example.com"
                />
            </div>
            <div className="form-group">
                <label>From</label>
                <input
                    type="email"
                    value={config.from || ''}
                    onChange={(e) => setConfig({...config, from: e.target.value})}
                    placeholder="sender@example.com"
                />
            </div>
            <div className="form-group">
                <label>Body</label>
                <textarea
                    value={config.body || ''}
                    onChange={(e) => setConfig({...config, body: e.target.value})}
                    placeholder="Enter email body"
                    rows={4}
                />
            </div>
        </div>
    );

    const renderDelayConfig = () => (
        <div className="drawer-section">
            <h4>Delay Configuration</h4>
            <div className="form-group">
                <label>Duration</label>
                <input
                    type="number"
                    value={config.duration || 60}
                    onChange={(e) => setConfig({...config, duration: parseInt(e.target.value) || 0})}
                    min="1"
                />
            </div>
            <div className="form-group">
                <label>Unit</label>
                <select
                    value={config.unit || 'minutes'}
                    onChange={(e) => setConfig({...config, unit: e.target.value})}
                >
                    <option value="seconds">Seconds</option>
                    <option value="minutes">Minutes</option>
                    <option value="hours">Hours</option>
                    <option value="days">Days</option>
                </select>
            </div>
        </div>
    );

    const renderConfig = () => {
        switch (step.type) {
            case 'email':
                return renderEmailConfig();
            case 'delay':
                return renderDelayConfig();
            default:
                return <div>Unknown step type</div>;
        }
    };

    return (
        <div className="block-drawer-overlay" onClick={onClose}>
            <div className="block-drawer" onClick={(e) => e.stopPropagation()}>
                <div className="drawer-header">
                    <h3>{step.title}</h3>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>
                <div className="drawer-content">
                    {renderConfig()}
                </div>
                <div className="drawer-footer">
                    <button className="btn btn-secondary" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary" onClick={handleSave}>
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BlockDrawer; 